export const industryOptions = [
  "Apparel & Fashion",
  "Beauty & Personal Care",
  "Health & Fitness",
  "Home & Living",
  "Food & Beverage",
  "Consumer Electronics",
  "Toys & Games",
  "Baby & Kids Products",
  "Pet Products",
  "Sports & Outdoor",
  "Jewelry & Luxury Goods",
  "Automotive Accessories",
  "Books & Stationery",
  "Fashion Accessories",
  "Gift & Subscription Boxes",
  "Events & Tickets",
  "Technology & Gadgets",
  "Food Delivery & Takeout",
  "Travel & Leisure",
  "Entertainment & Media",
  "Crafts & DIY",
  "Financial Services & Insurance",
  "Home Improvement & Tools",
  "Luxury Goods & Designer Products",
  "Online Learning & Digital Products",
];
